import React from 'react';
import LegalPersonForm from './LegalPersonForm';
import EffectiveControlForm from './EffectiveControlForm';
import FinalBeneficiariesForm from './FinalBeneficiariesForm';
import DeclaringLegalPersonForm from './DeclaringLegalPersonForm';

const forms = [
  {
    key: '1',
    title: 'Persona Jurídica',
    component: <LegalPersonForm />,
  },
  {
    key: '2',
    title: 'Beneficiarios Finales',
    component: <FinalBeneficiariesForm />,
  },
  {
    key: '3',
    title: 'Control Efectivo',
    component: <EffectiveControlForm />,
  },
  {
    key: '4',
    title: 'Persona Declarante',
    component: <DeclaringLegalPersonForm />,
  },
];

export default forms;
